/*
 * @Author: pengyong
 * @Date: 2020-11-18 23:30:29
 * @LastEditors: pengyong
 * @LastEditTime: 2020-11-18 23:46:33
 * @Description:
 * @FilePath: /exhibit/src/utils/encrypt.js
 */
import CryptoJS from "crypto-js";

function encrypt(src, key) {
    key = key.slice(0, 32);
    key = CryptoJS.enc.Utf8.parse(key);
    let iv = randomString(16);
    let ivutf8 = CryptoJS.enc.Utf8.parse(iv); //CryptoJS.enc.Utf8.parse("ccsyzz" + timestamp);
    let encrypted = CryptoJS.AES.encrypt(src, key, {
        iv: ivutf8,
        mode: CryptoJS.mode.CBC,
        adding: CryptoJS.pad.ZeroPadding
    }).toString();
    let dst = Buffer.from(iv + encrypted).toString("base64");
    console.log("dst:" + dst);
    return dst;
}

function randomString(length) {
    var str = Math.random()
        .toString(36)
        .substring(2);
    while (str.length < length) {
        str += Math.random()
            .toString(36)
            .substring(2);
    }
    return str.substring(0, length);
}

export default encrypt;

// 判断用户的设备
export const  isMobile = () =>  {
    // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    // alert(flag)
    // console.log(flag);
    // return flag;
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
        return true // 手机端
    } else {
        return false // alert('PC端')
    }
}

export const isWeiXin = () => {
    var ua = window.navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') > -1) {
        return true // 是微信端
    } else {
        return false
    }
}



// WEBPACK FOOTER //
// ./src/utils/encrypt.js